<template>
    <b-table class="table is-fullwidth background-color" :hoverable="true" :data='fetchSchoolUsers'>
        <b-table-column label="Name" v-slot="props" sortable>
          {{ props.row.name }}
        </b-table-column>
        <b-table-column label="Email" v-slot="props" sortable>
          {{ props.row.email }}
        </b-table-column>
        <b-table-column label="Mobile" v-slot="props" sortable>
          {{ props.row.mobile }}
        </b-table-column>
        <b-table-column label="Action" class="is-actions-cell" v-slot="props">
          <div class="buttons is-right" style="display:block">
            <button @click="edit(props.row._id)" class="button is-small is-primary"  type="button">
              <b-icon
                  icon="pencil"
                  size="is-small">
              </b-icon>
            </button>
            <button class="button is-small is-danger" type="button"  @click="delete(props.row._id)">
              <b-icon
                icon="delete"
                size="is-small">
              </b-icon>
            </button>
            <button v-if="type == 'P'" class="button is-small is-danger" type="button"  @click="delete(props.row._id)">
              <b-icon
                icon="chart-bar"
                size="is-small">
              </b-icon>
            </button>
          </div>
        </b-table-column>
    </b-table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name : 'user-table',
	props : {
        type:{
            type:String,
        }
	},
    methods: {
      ...mapActions(['loadSchoolUsers', 'deleteSchoolUser']),
    editSchoolUser(id) {
      this.edit_id = id
      this.modalEditPO = true
    },
    deleteSchoolUser(id) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure?',
        onConfirm: () => {
          this.deleteSchoolUser({ token: this.userToken, id }).then(() => {
            this.$buefy.toast.open({
              message: 'Teacher deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    },
    },
    computed: {
      ...mapGetters(['fetchSchoolTeachers', 'fetchSchoolStudents', 'getTeacherToken']),
      fetchSchoolUsers(){
        if(this.type=="P")
          return this.fetchSchoolStudents;
        else if(this.type=="ST")
          return this.fetchSchoolTeachers;
        else
          return [];
      }
    },
    created(){
        this.loadSchoolUsers({ token: this.getTeacherToken, type: this.type});
    },
}
</script>
<style scoped>
.button {
  flex-direction: row;
  width: 100%;
  background: #8919e7;
  color: #fff;
  gap: 1vw;
  cursor: pointer;
  position: relative;
  text-transform: capitalize;
  max-width: -webkit-fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  padding: 1.2vw 5vw;
  border-radius: 1.1vw;
  font-size: 1.2vw;
}
.button.outline {
  border: 0.063rem solid #8919e7;
  background: #fff;
  color: #000;
}
</style>
